<dhofar-shared-navbar
  [nameAr]="nameAr"
  [nameEn]="nameEn"
  (logoutEvent)="logout()"
  (redirectToPortalEvent)="navigateToPortal()"></dhofar-shared-navbar>
